import React from "react";
import i18next from "i18next";

const LanguageWidget = () => {
 

  return (
    <div className="row">
      <div className="col-6">
        <img
          src="/images/language/turkish-language.png"
          alt="Turkish Language"
          width={"25px"}
          style={{
            cursor: "pointer",
          }}
          onClick={() => {
            i18next.changeLanguage("tr");
          }}
        />
      </div>
      <div className="col-6">
        <img
          src="/images/language/english.png"
          alt="English Language"
          width={"40px"}
          style={{
            cursor: "pointer",
          }}
          onClick={() => {
            i18next.changeLanguage("en");
          }}
        />
      </div>
    </div>
  );
};

export default LanguageWidget;
